/** Extracts the application segment from a given path **/
export const getAppFromPath = (path: string): string => {
  return path.split('/').filter(Boolean)[0] || '';
};
